import React, { useState, useEffect } from 'react';
import client from '../api/client';
import { Save } from 'lucide-react';
import styles from './CommonPage.module.css';

const BannerPage = () => {
  const [title, setTitle] = useState('');
  const [link, setLink] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('#2563eb'); // Default blue
  const [textColor, setTextColor] = useState('#ffffff'); // Default white
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBanner();
  }, []);

  const fetchBanner = async () => {
    try {
      const response = await client.get('/admin/banner');
      if (response.data) {
        setTitle(response.data.title || '');
        setLink(response.data.link || '');
        setBackgroundColor(response.data.backgroundColor || '#2563eb');
        setTextColor(response.data.textColor || '#ffffff');
        setIsActive(response.data.isActive || false);
      }
    } catch (error) {
      console.error('Failed to fetch banner settings', error);
    }
  };

  const handleSave = async () => {
    if (!title) {
        alert('제목을 입력해주세요.');
        return;
    }
    setLoading(true);
    try {
      await client.post('/admin/banner', {
        title,
        link,
        backgroundColor,
        textColor,
        isActive
      });
      alert('배너 설정이 저장되었습니다.');
    } catch (error) {
      console.error('Failed to save banner', error);
      alert('저장에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>상단 배너 관리</h1>
      </div>

      <div className={styles.grid}>
        <div className={styles.formCard} style={{ maxWidth: '100%' }}>
            <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '1.2rem', fontWeight: 600 }}>배너 설정</h3>
            
            <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                {/* Active Switch */}
                <div className={styles.formGroup}>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input 
                            type="checkbox" 
                            id="isActive"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                            style={{ width: '20px', height: '20px' }}
                        />
                        <label htmlFor="isActive" style={{ margin: 0, cursor: 'pointer' }}>배너 활성화</label>
                    </div>
                </div>

                {/* Title */}
                <div className={styles.formGroup}>
                    <label>배너 문구 (제목)</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="예: 서비스 점검 안내 (01/15 02:00 ~ 04:00)"
                    />
                </div>

                {/* Link */}
                <div className={styles.formGroup}>
                    <label>이동 링크 (선택)</label>
                    <input
                        type="text"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        placeholder="https://..."
                    />
                </div>

                 {/* Background Color - Synced Inputs */}
                 <div className={styles.formGroup}>
                    <label>배경 색상</label>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <input
                            type="color"
                            value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}
                            style={{ width: '50px', height: '40px', padding: 0, border: 'none', cursor: 'pointer' }}
                        />
                        <input
                            type="text"
                            value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}
                            placeholder="#000000"
                            style={{ width: '150px', textTransform: 'uppercase' }}
                        />
                        <span style={{ fontSize: '0.8rem', color: '#666' }}>
                             배너 배경색
                        </span>
                    </div>
                </div>

                 {/* Text Color - Synced Inputs */}
                 <div className={styles.formGroup}>
                    <label>글자 색상</label>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <input
                            type="color"
                            value={textColor}
                            onChange={(e) => setTextColor(e.target.value)}
                            style={{ width: '50px', height: '40px', padding: 0, border: 'none', cursor: 'pointer' }}
                        />
                        <input
                            type="text"
                            value={textColor}
                            onChange={(e) => setTextColor(e.target.value)}
                            placeholder="#ffffff"
                            style={{ width: '150px', textTransform: 'uppercase' }}
                        />
                        <span style={{ fontSize: '0.8rem', color: '#666' }}>
                             배너 문구 색상
                        </span>
                    </div>
                </div>

                {/* Submit Button */}
                <div className={styles.formActions} style={{ marginTop: '24px' }}>
                    <button
                        type="button"
                        onClick={handleSave}
                        disabled={loading}
                        className={styles.primaryBtn}
                    >
                        <Save size={18} />
                        설정 저장
                    </button>
                </div>
            </form>
        </div>

        {/* Preview Section */}
        <div className={styles.card} style={{ height: 'fit-content' }}>
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '1.2rem', fontWeight: 600 }}>미리보기</h3>
            <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                <div style={{ pointerEvents: 'none', userSelect: 'none' }}>
                     {/* Mock Navbar */}
                    <div style={{ 
                        height: '48px', 
                        background: 'white', 
                        borderBottom: '1px solid #e5e7eb', 
                        display: 'flex', 
                        alignItems: 'center', 
                        padding: '0 16px',
                        color: '#9ca3af',
                        fontSize: '0.875rem'
                    }}>
                        Navbar Area
                    </div>
                     {/* Mock Banner */}
                     {isActive ? (
                        <div style={{ 
                            backgroundColor: backgroundColor, 
                            color: textColor,
                            padding: '8px', 
                            textAlign: 'center', 
                            fontSize: '0.875rem',
                            fontWeight: 500
                        }}>
                            <span>{title || '배너 문구가 여기에 표시됩니다.'}</span>
                        </div>
                     ) : (
                        <div style={{ 
                            padding: '8px', 
                            textAlign: 'center', 
                            color: '#9ca3af', 
                            fontSize: '0.875rem', 
                            background: '#f3f4f6', 
                            borderTop: '1px solid #e5e7eb', 
                            borderBottom: '1px solid #e5e7eb',
                            fontStyle: 'italic'
                        }}>
                            배너 비활성화 상태
                        </div>
                     )}
                     {/* Mock Content */}
                     <div style={{ height: '100px', background: 'white', padding: '16px', color: '#d1d5db', fontSize: '0.875rem' }}>
                        Main Content Area...
                     </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default BannerPage;
